import { Col, FloatingLabel, FormControl, FormSelect, Row } from "react-bootstrap";
import EnergoTooltip from "../../../shared/EnergoTooltip";

const NameMask = ({data, setData, formError, setFormError}) => {

    return (
        <>
            <p className="text-muted">
                <small>
                    Name und interne Objektbezeichnung der Liegenschaft (z.B. Mustergasse 44, Musterstadt; 1234)
                </small>
            </p>
            <Row>
                <Col xs="12">
                    <FloatingLabel label="Name">
                        <FormControl
                            placeholder="Name"
                            value={data.building_name}
                            onChange={e => {setData(prev => ({...prev, building_name: e.target.value})); setFormError({})}}
                            isValid={data.building_name.length > 3}
                            isInvalid={formError.building_name}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12">
                    <FloatingLabel label="Interne Objektbezeichnung">
                        <FormControl
                            placeholder="Interne Objektbezeichnung"
                            value={data.building_ident}
                            onChange={e => {setData(prev => ({...prev, building_ident: e.target.value})); setFormError({})}}
                            isValid={data.building_ident !== ""}
                            isInvalid={formError.building_ident}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3 align-items-center">
                <Col xs="10" md="6" xl="5">
                    <FloatingLabel label="Vorgang auswählen">
                        <FormSelect
                            value={data.vorgang}
                            onChange={e => {setData(prev => ({...prev, vorgang: e.target.value})); setFormError({})}}
                            isValid={data.vorgang !== ""}
                            isInvalid={formError.vorgang}
                        >
                            <option value="Erstbezugsobjekt">Erstbezugsobjekt</option>
                            <option value="Bestand erfassen">Bestand erfassen</option>
                            <option value="Hausverwaltungswechsel">Hausverwaltungswechsel</option>
                        </FormSelect>
                    </FloatingLabel>
                </Col>
                <Col xs="1" md="1" xl="1">
                    <EnergoTooltip tKey="8001" position="right" />
                </Col>
            </Row>
        </>
    )
}
export default NameMask;